import about from "../../../../assets/imageforabout/discussing.jpg";
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const Docabout = (props) => {

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <div id='about' style={{ padding: '70px 0', background: '#f8fafc' }}>
      <div className='container'>
        <div className='row' style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>

          {/* Image */}
          <div className='col-xs-12 col-md-6' data-aos='fade-right' data-aos-delay='100'>
            <div style={{
              borderRadius: 20,
              overflow: 'hidden',
              boxShadow: '0 8px 40px rgba(30,64,175,0.13)',
              position: 'relative',
            }}>
              <img
                src={about}
                className='img-responsive'
                alt='GyanBuddy KMS'
                style={{ width: '100%', height: 420, objectFit: 'cover', display: 'block' }}
              />
              {/* accent overlay */}
              <div style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(135deg, rgba(30,64,175,0.08) 0%, rgba(59,130,246,0.04) 100%)',
                pointerEvents: 'none',
              }} />
              {/* floating badge */}
              <div data-aos='zoom-in' data-aos-delay='500' style={{
                position: 'absolute', bottom: 24, left: 24,
                background: '#1e40af',
                color: '#fff',
                borderRadius: 12,
                padding: '10px 18px',
                fontSize: 13,
                fontWeight: 700,
                boxShadow: '0 4px 16px rgba(30,64,175,0.35)',
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                <i className="fa fa-brain" style={{ fontSize: 16 }} />
                AI-Powered Knowledge System
              </div>
            </div>
          </div>

          {/* Text */}
          <div className='col-xs-12 col-md-6' data-aos='fade-left' data-aos-delay='200'>
            <div style={{ padding: '0 10px' }}>

              {/* eyebrow */}
              <div data-aos='fade-down' data-aos-delay='250' style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: '#eff6ff', color: '#1e40af',
                borderRadius: 20, padding: '5px 16px',
                fontSize: 11, fontWeight: 700, letterSpacing: 1.1,
                marginBottom: 16,
              }}>
                <span style={{
                  width: 7, height: 7, borderRadius: '50%',
                  background: '#3b82f6', display: 'inline-block',
                }} />
                KNOWLEDGE MANAGEMENT
              </div>

              <h2 data-aos='fade-up' data-aos-delay='300' style={{
                fontSize: 'clamp(24px,3vw,34px)',
                fontWeight: 800, color: '#0f172a',
                lineHeight: 1.25, margin: '0 0 18px',
              }}>
                What is GyanBuddy KMS?
              </h2>

              <p data-aos='fade-up' data-aos-delay='380' style={{
                fontSize: 15.5, color: '#475569',
                lineHeight: 1.8, margin: '0 0 20px',
              }}>
                GyanBuddy KMS is a revolutionary knowledge management system that leverages the power of AI to transform how your organization accesses and utilizes information. It acts as a central repository for all your documents, making them readily searchable and accessible to everyone.
              </p>

              <p data-aos='fade-up' data-aos-delay='440' style={{
                fontSize: 15.5, color: '#475569',
                lineHeight: 1.8, margin: 0,
              }}>
                Imagine an organization-wide search that understands your intent and delivers relevant information instantly — combined with the conversational power of an internal AI assistant for real-time knowledge exchange.
              </p>

              {/* feature pills */}
              <div data-aos='fade-up' data-aos-delay='520' style={{
                display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 28,
              }}>
                {[
                  { icon: 'fa-search', label: 'Smart Search' },
                  { icon: 'fa-lock',   label: 'Secure Storage' },
                  { icon: 'fa-bolt',   label: 'Real-time AI' },
                  { icon: 'fa-globe',  label: 'Multi-language' },
                ].map(({ icon, label }) => (
                  <div key={label} style={{
                    display: 'inline-flex', alignItems: 'center', gap: 7,
                    background: '#fff', border: '1.5px solid #e2e8f0',
                    borderRadius: 10, padding: '7px 14px',
                    fontSize: 13, fontWeight: 600, color: '#1e293b',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                  }}>
                    <i className={`fa ${icon}`} style={{ color: '#3b82f6', fontSize: 12 }} />
                    {label}
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
